import axios from "axios"

export default {
  name: 'RemoteSVGInline',
  props: {
    src: {
      type: String,
      required: true
    },
    colorsDefault: {
      type: Array,
      default: () => ['white', '#999999']
    },
    colorsChange: {
      type: Array,
      default: () => ['white', '#999999']
    }
  },
  data() {
    return {
      finalSvg: ''
    }
  },
  mounted() {
    this.setSvg()
  },
  methods: {
    async setSvg() {
      const { data } = await axios.get(this.src)
      if (data.indexOf('<svg') === -1) {
        return
      }
      this.finalSvg = this.changeColor(data, this.colorsChange, this.colorsDefault)
    },

    changeColor(initSvg, newColors, oldColors) {
      let diff = false
      for (let i = 0; i < oldColors.length; i++) {
        if (oldColors[i] !== newColors[i]) {
          diff = true
          break
        }
      }
      /**
       * можно и вычлять помимо этого какие именно цвета в массиве
       * поменялись, но это уже оверхед, считаем, что если хотя один цвет
       * был изменен прогоняем полную замену
       */
      if (diff) {
        const replacedStr = oldColors.map(color => String.raw`${color}`).join('|')
        const re = RegExp(replacedStr, 'g')
        const mapObj = {}
        oldColors.forEach((color, index) => {
          mapObj[color] = newColors[index]
        });
        return initSvg.replace(re, (matched) => {
          return mapObj[matched]
        })
      }
      return initSvg
      
    }
  },
  watch: {
    colorsChange(newColors, oldColors) {
      if (this.finalSvg) {
        this.finalSvg = this.changeColor(this.finalSvg, newColors, oldColors)
      }
    }
  }
}